"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const styles_1 = require("@mui/material/styles");
const styled_components_1 = __importDefault(require("styled-components"));
const HappyConsumerSvg_1 = __importDefault(require("../../common/HappyConsumerSvg"));
const ImageHeaderContainer = styled_components_1.default.div `
  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "margin-bottom",
    values: { xs: "70px", md: "115px" },
})};
`;
const ImageContainer = styled_components_1.default.div `
  width: 100%;
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.palette.orange[0]};
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 95px;
  overflow: hidden;

  svg {
    height: 100px;
    margin-bottom: -15px;
  }
`;
const CloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 8px;
  right: 8px;
`;
const ImageHeader = ({ backgroundColor, closeIconColor, onClose, }) => {
    const theme = (0, styles_1.useTheme)();
    const r = (0, common_buoy_theme_1.useResponsive)();
    return ((0, jsx_runtime_1.jsxs)(ImageHeaderContainer, { children: [(0, jsx_runtime_1.jsx)(ImageContainer, { backgroundColor: backgroundColor, "data-testid": "header-svg", children: (0, jsx_runtime_1.jsx)(HappyConsumerSvg_1.default, {}) }), (0, jsx_runtime_1.jsx)(CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: onClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: closeIconColor || theme.palette.text.primary, size: r({ sm: 32, lg: 24 }) }) }) })] }));
};
exports.default = ImageHeader;
//# sourceMappingURL=index.js.map